import { updateSmoothScroll } from '../scroll-smoother'
import { loadElementLazyImage } from '../helpers/lazy-load'


// Filter posts
let filterMembers = $('.js-members-block')
if (filterMembers.length){

    filterMembers.each((i, block)=> {

        let $block = $(block)
        let $catButtons = $block.find('.js-cat-b')
        let $posts = $block.find('.js-post')


        $catButtons.click(function(){
            changeActive($(this))
            filterPosts()
        });

        $(document).ready(function () {
            $block.find('.js-cat-b').first().click()
        });

        function changeActive($this){
            let termId = $this.data('term-id')
            $catButtons.removeClass('active')
            $catButtons.each((i, el)=> {
                if ($(el).data('term-id') === termId) $(el).addClass('active')
            })
            $block.data('active-cat', termId)
        }

        const filterPosts = (cat) => {
            let termId = $block.data('active-cat')

            $posts.each(function(e, el){
                let add = 0
                let postCat = $(el).data('term-id')
                if (postCat === termId) add = 1

                if (add){
                    $(el).fadeIn()
                } else {
                    $(el).hide()
                    loadElementLazyImage($(el).find('.lazy'))
                }
            })
            updateSmoothScroll()
        }

    }) // end filter posts foreach
}
